import LandingPageContainer from './LandingPageContainer';

export default LandingPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/LandingPage/index.js